import { getCategoryHref } from '../../utils/common/category';
import { BLOG_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'blogIdeaGeneratorType',
      analyticsName: 'blog_idea_type',
      textLabel: 'Generate blog ideas for ...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: BLOG_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Blog',
        value: getCategoryHref(BLOG_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'blogIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'blog_ideas_generator',
      placeholder: 'Try "online ads" or "keto diet"',
      textLabel: 'Describe your blog topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: BLOG_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
